import React, { useState } from 'react';
import { FaHome, FaBars, FaTimes, FaBolt } from 'react-icons/fa';

const HomePage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Provider list removed – simplifying homepage to hero + guidance

  const menuItems = [
    { icon: <FaHome className="mr-1" />, text: 'Home', href: '/' },
  ];

  // No provider selection on homepage anymore

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Removed provider tile styles and related UI

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Header */}
      <header className="bg-white shadow-md relative">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center space-x-2">
             <img
                  src={process.env.REACT_APP_KRUOZ_IMAGE_BASE_URL + 'EasyHireQuates.png'}
                  alt="EasyHireQuotes"
                  className="h-12 w-auto"
                />
            {/* <span className="text-2xl font-bold text-blue-600">EasyHireQuotes</span> */}
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:block">
            <ul className="flex space-x-6">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a 
                    href={item.href} 
                    className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
                    target={item.target}
                    rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                  >
                    {item.icon}
                    <span>{item.text}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          {/* Mobile menu button */}
          <button 
            className="md:hidden text-gray-600 hover:text-blue-600 transition-colors"
            onClick={toggleMobileMenu}
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden bg-white border-t border-gray-200">
            <ul className="py-2">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a 
                    href={item.href} 
                    className="flex items-center px-4 py-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600 transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                    target={item.target}
                    rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                  >
                    {item.icon}
                    <span>{item.text}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </header>
      
      {/* Main Content */}
      <main className="flex-grow container mx-auto px-4 py-12">
        {/* Hero */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">Welcome to EasyHireQuotes</h1>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Get fast, reliable quotes from trusted providers. Explore how it works below.
          </p>
        </div>
        
        {/* How it works section */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-6 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">🔍</div>
              <h3 className="text-xl font-semibold mb-2">1. Tell Us What You Need</h3>
              <p className="text-gray-700">Share your requirements so providers can prepare accurate quotes</p>
            </div>
            <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-6 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">📝</div>
              <h3 className="text-xl font-semibold mb-2">2. Submit Requirements</h3>
              <p className="text-gray-700">Provide details about your needs for accurate quotes</p>
            </div>
            <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-6 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">💼</div>
              <h3 className="text-xl font-semibold mb-2">3. Receive Quotes</h3>
              <p className="text-gray-700">Get instant Flash Quotes where available, or receive custom quotations</p>
            </div>
          </div>
        </div>

        {/* Flash Quotes Feature */}
        <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 p-8 rounded-lg shadow-md mb-20">
          <h2 className="text-3xl font-bold mb-4 text-center text-gray-800">Flash Quotes Feature</h2>
          <p className="text-lg text-gray-700 mb-6 text-center">
            Some providers offer instant Flash Quotes for quick and easy pricing <FaBolt className="inline text-yellow-500" />
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="mb-4">© {new Date().getFullYear()} EasyHireQuotes. All rights reserved.</p>
          <div className="flex flex-wrap justify-center space-x-4">
            {/* <a href="/privacy-policy" className="hover:text-blue-400 transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-blue-400 transition-colors">Terms of Service</a>
            <a href="/contact" className="hover:text-blue-400 transition-colors">Contact</a> */}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;